import { render, staticRenderFns } from "./bar-horizontal.component.vue?vue&type=template&id=f1dd9a4a&scoped=true&"
import script from "./bar-horizontal.component.vue?vue&type=script&lang=js&"
export * from "./bar-horizontal.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dd9a4a",
  null
  
)

export default component.exports